import React from "react";
import { DocumentShareIcon, Pane, Text, useTheme } from "evergreen-ui";
import useControlHub from "../../hooks/useControlHub";

const APStatus = () => {
  const { company } = useControlHub();
  const theme = useTheme();

  return (
    <Pane
      borderColor={theme.colors.dark}
      borderWidth={1}
      borderRadius={theme.radii[1]}
      borderStyle="solid"
      display="inline-flex"
      alignItems="center"
      fontSize={12}
      marginRight={16}
      paddingBottom={2}
      paddingX={8}
      paddingTop={4}
    >
      <Text verticalAlign="middle" textAlign="right" size={300}>
        <DocumentShareIcon size={12} />
        {" Sent to "}
        {company.features.apInboxName || "AP System"}
      </Text>
    </Pane>
  );
};

export default APStatus;
